import { Injectable } from '@angular/core';
import { PartnerLinkListAdapter } from './partner-link-list.adapter';
import { Observable } from 'rxjs';
import { GGProductRetailersListWsDTO } from './occ.partner-link-list.adapter';

@Injectable()
export class PartnerLinkListConnector {
  constructor(private partnerAdapter: PartnerLinkListAdapter) {}

  fetchPartnerLinkList(actionType: string, productCode: string): Observable<GGProductRetailersListWsDTO> {
    return this.partnerAdapter.fetchPartnerLinkList(actionType, productCode);
  }
}
